import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TuitionApply from "../../../Apply";
import BreadCrumbs from "../../../../../components/common/BreadCrumbs/BreadCrumbs";

/**
 * TuitionErrorCorrection - Wrapper component for the error correction flow
 * 
 * This component:
 * - Provides proper routing context (/admin/tuition/errors-to-correct)
 * - Shows error correction breadcrumbs and headers
 * - Loads application data and errors
 * - Passes error correction state to TuitionApply
 */

interface TuitionErrorCorrectionProps {
  // Future: Can add props for customization
}

const TuitionErrorCorrection: React.FC<TuitionErrorCorrectionProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get data passed from AdministerSystem
  const errorsFromState = location.state?.errors || [];
  const applicationId = location.state?.applicationId;



  useEffect(() => {
    // Validate that we have necessary data
    if (!applicationId || errorsFromState.length === 0) {
      console.warn("No errors or applicationId found. Redirecting to administer system.");
      navigate("/admin/administer", { replace: true });
    }
  }, [applicationId, errorsFromState, navigate]);



  if (!applicationId || errorsFromState.length === 0) {
    return null; // Will redirect in useEffect
  }

  const handlePreviousClick = () => {
    navigate("/admin/administer");
  };

  return (
    <div className="tuition-error-correction lg:mx-40! mx-5! min-h-[70vh]">
      {/* Breadcrumbs for Error Correction Context */}
      <BreadCrumbs
        previousPage="Administer system"
        currentPage="Correct errors"
        onPreviousClick={handlePreviousClick}
      />

      <h1 className="h1 mt-8!">Fix Errors</h1>

  

      {/* Pass to TuitionApply with error correction state */}
      <TuitionApply 
        mode="admin" 
        // Error correction state will be picked up from location.state
        // in TuitionApplyContainer
      />
    </div>
  );
};

export default TuitionErrorCorrection;
